export const FETCH_CARS = {
  INIT: 'fetchCarsInit',
  LOADING: 'fetchCarsLoading',
  SUCCESS: 'fetchCarsSuccess',
  FAIL: 'fetchCarsFail',
  NEXT_LOADING: 'fetchNextCarsLoading',
  NEXT_SUCCESS: 'fetchNextCarsSuccess',
  NEXT_FAIL: 'fetchNextCarsFail',
};
